import { useState } from 'react'
import SpotlightButton from '../ui/SpotlightButton'

interface HeroSectionProps {
  heroLogoRef?: React.RefObject<HTMLImageElement>
}

const HeroSection = ({ heroLogoRef }: HeroSectionProps) => {
  const [email, setEmail] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const message = `Hola, quiero solicitar una demo. Mi correo es: ${email}`
    const whatsappUrl = `https://wa.me/573168751263?text=${encodeURIComponent(message)}`

    window.open(whatsappUrl, '_blank')

    setEmail('')
    setIsModalOpen(false)
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setEmail('')
  }

  return (
    <section id="inicio" className="flex items-center justify-center text-center text-white pt-[100px] pb-[100px] px-4">
      <div className="max-w-[1200px] mx-auto w-full">
        <img
          ref={heroLogoRef}
          src="/assets/images/Logo APP 2.svg"
          alt="Ruky"
          className="h-auto mb-5 block mx-auto hero-logo opacity-0 w-[120px] sm:w-[150px] md:w-[200px]"
        />

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] font-normal -mt-4 mb-6">
          Transforma tu granja porcina
        </h2>

        <p className="max-w-[600px] mx-auto mb-8 text-base sm:text-lg md:text-[1.1rem] opacity-90 px-4">
          Únete a la nueva era de la porcicultura. Datos precisos, salud
          animal y eficiencia operativa en una sola plataforma inmersiva.
        </p>

        {/* Formulario completo - solo visible en PC */}
        <div className="hidden sm:flex flex-col items-center mb-8">
          <form
            onSubmit={handleSubmit}
            className="bg-white/40 backdrop-blur-[20px] shadow-lg p-[5px] rounded-[50px] inline-flex items-center gap-0"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Tu correo electrónico"
              required
              className="bg-transparent border-0 px-5 py-3 text-white w-[300px] outline-none placeholder:text-white/70"
            />
            <SpotlightButton type="submit" className="flex-shrink-0">
              Solicitar Demo
            </SpotlightButton>
          </form>
        </div>

        {/* Botón solo - visible solo en móvil */}
        <SpotlightButton
          onClick={openModal}
          className="block sm:hidden mx-auto mb-8 px-8"
        >
          Solicitar Demo
        </SpotlightButton>

        <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-5 px-4">
          <a
            href="https://wa.me/573168751263?text=Hola%2C%20quiero%20descargar%20la%20app%20para%20iOS"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2.5 bg-white/40 text-white px-5 py-2.5 rounded-xl text-sm transition-all duration-300 hover:bg-black/60 backdrop-blur-[10px]"
          >
            <img src="/assets/images/apple.svg" alt="iOS" className="h-5" />
            iOS App
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.masdemotic.rukyfarm"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2.5 bg-white/40 text-white px-5 py-2.5 rounded-xl text-sm transition-all duration-300 hover:bg-black/60 backdrop-blur-[10px]"
          >
            <img src="/assets/images/android.svg" alt="Android" className="h-5" />
            Android App
          </a>
        </div>

        {/* Modal para móvil */}
        {isModalOpen && (
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[200] flex items-center justify-center p-4"
            onClick={closeModal}
          >
            <div
              className="bg-white rounded-[30px] p-8 max-w-[400px] w-full relative"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Botón cerrar */}
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 text-[#212121] text-2xl font-bold w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-all"
              >
                ×
              </button>

              <h3 className="text-2xl font-bold text-[#212121] mb-2 text-center">
                Solicitar Demo
              </h3>
              <p className="text-[#666] text-sm mb-6 text-center">
                Déjanos tu correo y te contactaremos pronto
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Tu correo electrónico"
                  required
                  className="w-full px-5 py-3 border-2 border-gray-200 rounded-[15px] text-[#212121] outline-none focus:border-[#FF3F34] transition-all"
                />
                <SpotlightButton type="submit" className="w-full">
                  Enviar
                </SpotlightButton>
              </form>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default HeroSection
